import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isNil, isEmpty } from 'lodash';
import locale from 'antd/lib/date-picker/locale/el_GR';
import {
  Select,
  DatePicker,
  Row,
  Col,
  Table,
  Divider,
  Space,
  Tooltip,
  Spin,
  AutoComplete,
  Input,
  Modal,
  Slider,
} from 'antd';
import { ReactComponent as SearchIcon } from '../../../assets/icons/search_icon.gov.svg';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/dropdown-arrow.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar.gov.svg';
import {
  clearSayt,
  fetchProcessSAYT,
  getActions,
  fetchFundingApplications,
} from 'store/appTrack/actions';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter_lines.svg';
import { ReactComponent as FilterIconBold } from '../../../assets/icons/filter_lines_bold.svg';
import Popover from '@mui/material/Popover';
import ActionList from './components/ActionList';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useNavigate } from 'react-router-dom';
import NoResults from './components/NoResults';
import { setActiveFormId } from 'store/activeForm/actions';
import { ReactComponent as CancelWarningIcon } from '../../../assets/icons/cancel_warning_icon.svg';
import { ReactComponent as ClearIcon } from '../../../assets/icons/clear-icon.svg';
import { ReactComponent as ApptrackSubmit } from '../../../assets/icons/apptrackSubmit.svg';
import { TABLE_DATA } from './components/dummyData';
import { ExpandIcon, getColumns } from './components/table';
import styles from './components/ResultsTable.module.scss';

const AppTrackPage = () => {
  const viewMode = false;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProcId, setSelectedProcId] = useState();
  const [isFiltersVisible, setFiltersVisible] = useState(false);
  const [filterImg, setFilterImg] = useState(<FilterIcon />);
  const user = useSelector(state => state.user);
  const userStatus = useSelector(state => state.user.status);
  const [saytOptions, setSaytOptions] = useState([]);
  const [detailedPayload, setDetailedPayload] = useState({ parameterList: [] });
  const privileges = useSelector(state => state.user.privileges);
  const groups = useSelector(state => state.user.groups);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(Boolean(anchorEl));
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const results = useSelector(state => state.appTrack?.variables);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const locales = useSelector(state => state.forms?.localeStrings);
  const loadingPage = useSelector(state => state.appTrack.loadingApptrack);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSizeFlag, setPageSizeFlag] = useState(5);
  const taskNames = useSelector(state => state.appTrack.taskNames);
  const sayt = useSelector(state => state.appTrack.sayt);
  const isProvider = user.groups
    ?.map(item => item.name)
    .includes('ProviderResourceGroup');
  const resultSize = useSelector(state => state.appTrack.resultSize);
  const [searchVar, setSearchvar] = useState('');
  const prefix = <SearchIcon style={{ marginRight: '14px' }} />;
  const suffix = (
    <ClearIcon
      onClick={() => setSearchvar('')}
      style={{ marginRight: '14px' }}
    />
  );
  const [activeTaskId, setActiveTaskId] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const loadingLocales = useSelector(state => state.forms.loadingLocales);
  const loadingTaxis = useSelector(state => state.user.loading);

  const dateFormat = 'DD/MM/YYYY';
  const filterText = isFiltersVisible ? 'filterText' : 'filterTextDefault';

  const id = open ? 'simple-popover' : 'simple-popover';

  const resultsArr = Array.isArray(results) ? results : Object.values(results);
  const dataSource =
    resultsArr?.map(record => ({
      ...record,
      children: [
        {
          id: `${record.id}-detail`,
          isDetail: true,
          programs: record.programs,
          fundingScheme: record.fundingScheme,
        },
      ],
    })) || [];

  const onMoreClick = (id, b_key, taskId) => event => {
    setSelectedProcId(id);
    setActiveTaskId(taskId);
    dispatch(setActiveFormId(id));
    // dispatch(getActions(id));

    // setSelectedBusinessKey(b_key);
    // setSelectedBusKey(b_key);
    setAnchorEl(event.currentTarget);
    setOpen(true);
    //  setTimeout(() => setOpen(true), 200)
    // setUsers([]);
    // setSelectedUser(null);
    // setAssignDisabled(false);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const renderTitle = title => <span>{title}</span>;

  const renderItem = title => ({
    value: title,
    label: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {title}
      </div>
    ),
  });

  useEffect(() => {
    dispatch(
      fetchFundingApplications(detailedPayload, currentPage, pageSizeFlag)
    );
  }, [currentPage, pageSizeFlag, detailedPayload]);

  useEffect(() => {
    if (sayt && !isEmpty(sayt)) {
      const saytOptionsTmp = [];
      Object.values(sayt).map(key => {
        const opt = { options: [] };
        if (key?.name != 'limitExceeded') {
          if (key?.name == 'legalVat') {
            opt.label = renderTitle('Α.Φ.Μ.');
          } else if (key?.name == 'businessKey') {
            opt.label = renderTitle('Αρ Αίτησης');
          } else if (key?.name == 'companyName') {
            opt.label = renderTitle('Επωνυμία');
          }
          const uniqueValues = new Set();

          for (let value of key?.values) {
            if (!uniqueValues.has(value.value)) {
              uniqueValues.add(value.value);
              opt.options.push(renderItem(value.value));
            }
          }
          saytOptionsTmp.push(opt);
        }
      });
      setSaytOptions(saytOptionsTmp);
    } else {
      setSaytOptions([]);
    }
  }, [sayt]);

  const onSAYTSelect = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTSearch = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('sayt'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'sayt') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'sayt',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSAYTChange = value => {
    if (value.length == 0) {
      dispatch(clearSayt());
      setSaytOptions([]);
      const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'sayt'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const handleSAYT = value => {
    if (value.length >= 3) {
      dispatch(fetchProcessSAYT(value));
    }
  };

  const toggleFilters = () => {
    setFiltersVisible(!isFiltersVisible);
    if (isFiltersVisible) {
      setFilterImg(<FilterIcon />);
    } else {
      setFilterImg(<FilterIconBold />);
    }
  };

  const overFilter = () => {
    setFilterImg(<FilterIconBold />);
  };

  const outFilter = () => {
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold />);
    } else {
      setFilterImg(<FilterIcon />);
    }
  };

  const onStatusChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));
    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('parseFlag'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'parseFlag') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'parseFlag',
          type: 'BOOLEAN',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'parseFlag'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onFilterChange = (value, qualifier, type) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes(qualifier))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === qualifier) {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: qualifier,
          type: type,
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== qualifier
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onDateRangeChange = (value, dateString) => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (!isEmpty(dateString[0]) && !isEmpty(dateString[1])) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'custom_submission_date') {
            return { ...obj, from: dateString[0], to: dateString[1] };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'custom_submission_date',
          type: 'RANGE_DATE',
          from: dateString[0],
          to: dateString[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'custom_submission_date'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onSliderChange = value => {
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      const index = detailedPayloadTmp.parameterList.findIndex(
        obj => obj.qualifier === 'loanPercentage'
      );

      if (!isNil(value[0]) && !isNil(value[1])) {
        if (index !== -1) {
          detailedPayloadTmp.parameterList[index].from = value[0];
          detailedPayloadTmp.parameterList[index].to = value[1];
        } else {
          detailedPayloadTmp.parameterList.push({
            qualifier: 'loanPercentage',
            type: 'RANGE_INTEGER',
            from: value[0],
            to: value[1],
          });
        }

        setDetailedPayload(detailedPayloadTmp);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'loanPercentage',
          type: 'RANGE_INTEGER',
          from: value[0],
          to: value[1],
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'loanPercentage'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const Auditormarks = {
    100: '100%',
    0: '0%',
  };

  return (
    <div className="apptrack-wrapper">
      <div className="main-container">
        <Modal
          id={`cancel-modal-${selectedProcId}`}
          centered
          width={400}
          open={cancelModal}
          className={`custom-modal`}
          onCancel={() => setCancelModal(false)}
          onOk={() => setCancelModal(false)}
          closable={false}
          footer={null}
        >
          <div className="image_modal">
            <CancelWarningIcon />
          </div>
          <div className="modal_info">
            <h3>Επιβεβαίωση Ακύρωσης Αίτησης</h3>
            <p>Είστε σίγουροι ότι επιθυμείτε να ακυρώσετε την αίτησή σας;</p>
            <p>Προσοχή η ενέργεια είναι μη αναστρέψιμη.</p>
          </div>
          <div className="footerBtnContainer">
            <div
              id={'cancel-modal-cancel-button'}
              className="cancel-btn-assign"
              onClick={() => setCancelModal(false)}
            >
              Επιστροφή
            </div>
            <div
              id={`cancel-modal-ok-button-${selectedProcId}`}
              onClick={() => ''}
              className="btn-assign"
            >
              Επιβεβαίωση
            </div>
          </div>
        </Modal>

        <Modal
          id={`after-submit-modal-${selectedProcId}`}
          centered
          width={400}
          open={showSubmitModal}
          className={`custom-modal`}
          onCancel={() => setShowSubmitModal(false)}
          onOk={() => setShowSubmitModal(false)}
          closable={false}
          footer={null}
        >
          <div className="image_modal">
            <ApptrackSubmit />
          </div>
          <div className="modal_info">
            <h3>Η αίτησή σας υποβλήθηκε με επιτυχία.</h3>
            <p>
              Το Business Plan σας δημιουργείται αυτόματα και θα προωθηθεί στο
              Center of Excellence.
            </p>
            <p>Θα λάβετε σχετική ενημέρωση για τα επόμενα βήματα.</p>
          </div>
          <div className="footerBtnContainer">
            <div
              id={'cancel-modal-cancel-button'}
              className="cancel-btn-assign"
              onClick={() => setShowSubmitModal(false)}
            >
              Επιστροφή
            </div>
          </div>
        </Modal>

        <Modal
          id={`after-submit-modal-${selectedProcId}`}
          centered
          width={400}
          open={showUpdateModal}
          className={`custom-modal`}
          onCancel={() => setShowUpdateModal(false)}
          onOk={() => setShowUpdateModal(false)}
          closable={false}
          footer={null}
        >
          <div className="image_modal">
            <ApptrackSubmit />
          </div>
          <div className="modal_info">
            <h3>Η ενημέρωση του αρχείου ήταν επιτυχής.</h3>
            <p>
              Παρακαλώ περιμένετε μερικά λεπτά για την επαναδημιουργία του
              Επενδυτικού Σχεδίου.
            </p>
          </div>
          <div className="footerBtnContainer">
            <div
              id={'cancel-modal-cancel-button'}
              className="cancel-btn-assign"
              onClick={() => setShowUpdateModal(false)}
            >
              Επιστροφή
            </div>
          </div>
        </Modal>

        <div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <ActionList
              open={setOpen}
              id={selectedProcId}
              taskId={activeTaskId}
              payload={detailedPayload}
              setCancelModal={setCancelModal}
            />
          </Popover>
        </div>

        <div style={{ marginTop: '30px', marginBottom: '21px' }}>
          <div>
            {privileges?.includes('CanRenderSAYT') && false && (
              <div style={{ marginTop: '30px', marginBottom: '21px' }}>
                <AutoComplete
                  popupClassName="certain-category-search-dropdown"
                  dropdownMatchSelectWidth={500}
                  style={{ width: '100%' }}
                  options={saytOptions}
                  onSearch={handleSAYT}
                  onSelect={onSAYTSelect}
                  onChange={onSAYTChange}
                  defaultValue={detailedPayload?.saytKey}
                >
                  <Input.Search
                    id="autocomplete-search-input"
                    onSearch={onSAYTSearch}
                    bordered={false}
                    allowClear={true}
                    prefix={prefix}
                    className="sayt-input-filter input-filter"
                    size="large"
                    placeholder="Αναζήτηση με Α.Φ.Μ., Αρ. Αίτησης, Επωνυμία"
                    enterButton
                  />
                </AutoComplete>
              </div>
            )}
          </div>

          {privileges?.includes('CanRenderAppFilters') && (
            <div>
              <Tooltip placement="right" title="Expanded Filters">
                <Space
                  id="filters-toggle-button"
                  onClick={() => toggleFilters()}
                  onMouseEnter={() => overFilter()}
                  onMouseLeave={() => outFilter()}
                  className="filterButton mt-3"
                >
                  {filterImg}
                  <span className={filterText}>
                    {getLocalString(
                      locales,
                      localNames.HOME_PAGE_FILTERSBUTTON
                    )}
                  </span>
                </Space>
              </Tooltip>

              {isFiltersVisible && (
                <div className="filtersContainer">
                  <div className="filters-wrapper">
                    <div style={{ flex: '1' }}>
                      <Select
                        id="select-application-status"
                        suffixIcon={<ArrowIcon />}
                        className="input-filter"
                        style={{ width: '100%' }}
                        dropdownAlign={{ offset: [-11, 5] }}
                        showSearch
                        allowClear={true}
                        placeholder={
                          getLocalString(
                            locales,
                            localNames?.HOME_PAGE_FILTERS_STATUS
                          ) || 'Status'
                        }
                        optionFilterProp="children"
                        onChange={onStatusChange}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        <Option value={false}>Center of Excellence</Option>
                        <Option value={true}>
                          Center of Excellence BP Pending
                        </Option>
                      </Select>
                    </div>

                    <div style={{ flex: '1' }}>
                      <RangePicker
                        id="application-results-date-range-picker-from"
                        locale={{
                          ...locale,
                          lang: {
                            ...locale.lang,
                            rangePlaceholder: [
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_DATEFROM
                              ),
                              getLocalString(
                                locales,
                                localNames.HOME_PAGE_FILTERS_DATETO
                              ),
                            ],
                          },
                        }}
                        format={dateFormat}
                        suffixIcon={<CalendarIcon />}
                        allowEmpty={[true, true]}
                        onCalendarChange={onDateRangeChange}
                        className="input-filter"
                        style={{ width: '100%', height: 'unset !important' }}
                      />
                    </div>

                    <div style={{ flex: '1' }} className="slider-wrapper">
                      <span className="slider-label-expenditure">
                        % Συμμετοχής ΤΑΑ στη Δαπάνη
                      </span>
                      <Slider
                        className="sliderexpenditure"
                        max={100}
                        min={0}
                        step={1}
                        marks={Auditormarks}
                        onAfterChange={onSliderChange}
                        range
                        defaultValue={[0, 100]}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* <Divider></Divider> */}
        </div>

        {loadingPage && (
          <div className="custom-spinner">
            <div>
              <Spin
                id="apptrack-application-results-table-spinner"
                size="large"
              />
            </div>
          </div>
        )}

        {!loadingPage && !isEmpty(dataSource) && (
          <Row gutter={32} >
            <Col span={24}>
              <div className={styles.resultsTableWrapper} style={{ marginTop: '30px', marginBottom: '21px' }}>
                <Table
                  scroll={{ x: 'max-content' }}
                  id="apptrack-application-results-table"
                  className="results-table results-table--no-x-scroll"
                  dataSource={dataSource}
                  columns={getColumns(onMoreClick, id)}
                  rowKey="id"
                  childrenColumnName="children"
                  expandable={{
                    expandRowByClick: false,
                    expandIcon: ({ expanded, onExpand, record }) => (
                      <ExpandIcon
                        expanded={expanded}
                        onExpand={onExpand}
                        record={record}
                        expandable={!record.isDetail}
                      />
                    ),
                    rowExpandable: record => !!record.children?.length,
                    indentSize: 0,
                  }}
                  pagination={{
                    total: resultSize,
                    current: currentPage,
                    showSizeChanger: true,
                    showTitle: true,
                    pageSizeOptions: [5, 10, 20, 50, 100, 200],
                    pageSize: pageSizeFlag,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setPageSizeFlag(pageSize);
                      dispatch(
                        fetchFundingApplications(
                          detailedPayload,
                          page,
                          pageSize
                        )
                      );
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
        )}

        {!loadingPage && isEmpty(dataSource) && (
          <NoResults
            id="apptrack-application-results-no-results"
            description={'Δε βρέθηκαν αποτελέσματα'}
            subDescription={''}
          />
        )}
      </div>
    </div>
  );
};

export default AppTrackPage;
